import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CompanyInfo.css";
import corpImg from '../../assets/corp.jpg';

const CompanyInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row>
          {/* Left Side Content */}
          <Col xs={12} md={8} className="slide-in-left mb-4 mb-md-0">
            <h1 className="text-primary2 fw-bold mb-4 text-center text-md-start">Corporate Events</h1>
            
            <Row>
              <Col xs={12} sm={6}>
                <img
                  src={corpImg}
                  alt="Corporate Event"
                  className="img-fluid mb-3 company-image"
                />
              </Col>
              <Col xs={12} sm={6} className="text-white">
                <h4 className="text-white mt-4 mb-3 text-center text-sm-start">Our Corporate Event</h4>
                <ul className="event-services-list">
                  <li>Recognition & Reward (R&R)</li>
                  <li>Conferences</li>
                  <li>Seminars</li>
                  <li>Product Launches</li>
                  <li>Team-Building Activities</li>
                  <li>Corporate Retreats</li>
                </ul>
              </Col>
            </Row>

            <p className="text-white mt-3">
              Welcome to Zarinova Entertainment, your premier partner in creating unforgettable corporate events. At Zarinova Entertainment, we specialize in transforming ordinary gatherings into extraordinary experiences. Whether you're planning a conference, a product launch, a gala, or a team-building retreat, our team of seasoned professionals is dedicated to delivering flawless events tailored to your unique vision and goals.
            </p>
          </Col>

          {/* Right Side Form */}
          <Col xs={12} md={4} className="slide-in-right">
            <Card className="get-in-touch-card mt-4">
              <Card.Body>
                <h5 className="fw-bold text-white">GET IN TOUCH</h5>
                <p className="small text-white">
                  PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION
                </p>
                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="YOUR COMMENT"
                    />
                  </Form.Group>

                  <Button
                    variant="warning1"
                    className="learn-more-btn rounded-pill px-4 py-2 text-white w-100"
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CompanyInfo;
